module.exports = __webpack_public_path__ + "static/media/icons_Bilan découverte - général.9adee5cd.svg";